package info.rezident.app

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.loadFromLocalStorage
import com.varabyte.kobweb.silk.theme.colors.saveToLocalStorage
import com.varabyte.kobweb.silk.theme.colors.systemPreference
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.analytics.analytics
import dev.gitlive.firebase.initialize
import info.rezident.app.core.isLocalEnvironment
import info.rezident.app.data.auth.AuthRepository
import info.rezident.app.data.user.VariantsRepository
import info.rezident.app.seo.HtmlLangRo
import info.rezident.app.ui.theme.AppTheme
import org.jetbrains.compose.web.css.vh

@InitSilk
fun initColorMode(ctx: InitSilkContext) {
    ctx.config.initialColorMode = ColorMode.loadFromLocalStorage() ?: ColorMode.systemPreference
}

@InitSilk
fun initFirebase(ctx: InitSilkContext) {
    Firebase.initialize(
        options =
//            if (isLocalEnvironment()) {
//            FirebaseOptions(
//                apiKey = "AIzaSyC9Kd1EA8qzi-F-emENjVe0-gvAWtB3nDQ",
//                authDomain = "rezident-info-dev.firebaseapp.com",
//                projectId = "rezident-info-dev",
//                storageBucket = "rezident-info-dev.firebasestorage.app",
//                gcmSenderId = "203818676574",
//                applicationId = "1:203818676574:web:29534d9d45ce983cb2dfcf",
//                gaTrackingId = "G-4VJKQMFR8C"
//            )
//        } else {
            FirebaseOptions(
                apiKey = "AIzaSyDcfN_YlDZVd-dQiyU02FiiLQncPj3ycYo",
                authDomain = "rezident.info",
                projectId = "rezident-info",
                storageBucket = "rezident-info.firebasestorage.app",
                gcmSenderId = "701270043234",
                applicationId = "1:701270043234:web:852d50a5021cb637343f3b",
                gaTrackingId = "G-DYWPRPR0KQ"
            )
//        }
    )

    if (isLocalEnvironment()) {
        Firebase.analytics.setAnalyticsCollectionEnabled(false)
    }
}

@InitSilk
fun appInit(ctx: InitSilkContext) {
    AuthRepository.initAuth()
    VariantsRepository.initRemoteConfig()
}

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    SilkApp {
        val colorMode = ColorMode.current
        LaunchedEffect(colorMode) {
            colorMode.saveToLocalStorage()
        }

        AppTheme(
            SmoothColorStyle.toModifier()
                .minHeight(100.vh)
                .scrollBehavior(ScrollBehavior.Smooth)
        ) {
            HtmlLangRo()
            content()
        }
    }
}
